export default "__VITE_ASSET__ed44b4ee__"